<template>
  <div id="app" :class="routeName">
    <VSpinner/>
    <div class="container">
      <RouterView/>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import VSpinner from '@/components/commons/VSpinner.vue';
import internetConnectivityMixin from '@/utils/mixins/internetConnectivity';
import { Notification } from '@/utils/helpers/notification';

export default {
  name: 'App',
  mixins: [
    internetConnectivityMixin,
  ],
  components: {
    VSpinner,
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    ...mapState({
      modalDisplay: ({ modal }) => modal.data.modalDisplay,
      csat: ({ modal }) => modal.data.csat.display,
    }),
  },
  methods: {
    handleInternetConnectivity() {
      this.$on('internet_connectivity_status', (status) => {
        this.notifyInternectConnectivityStatus(status);
      });
    },

    notifyInternectConnectivityStatus(status) {
      if (status) {
        setTimeout(() => {
          Notification.clearAll();
        }, 2000);
        return;
      }

      Notification.show({
        closeOnSwipe: false,
        hasOverlay: true,
        message: 'Você parece estar offline. Verifique sua conexão ou tente mais tarde.'
      });
    }
  },
  created() {
    this.handleInternetConnectivity();
  }
};
</script>
<style lang="scss">
#app {
  text-align: center;
}
</style>
